import React, { useEffect, useState } from 'react'
import AppApi from '../../api/app';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { AiOutlineEdit } from 'react-icons/ai';


let RecentOrders = () => {
    let setting = useSelector(data => data?.profile?.data?.setting);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        updateBrandsListOrder();
    }, []);

    let updateBrandsListOrder = (list) => {
        try {
            AppApi.recentOrders()
                .then(async (res) => {
                    if (res?.status == 200) {
                        setData(res?.data?.data?.data);
                        setLoading(false)
                    }
                })
        } catch (error) {
            console.log(error.message);
        }
    }


    return (
        <>
            <div className="card p-3 dashboard-card">
                <div className="card-heading">
                    <h4>Recent Orders</h4> 
                </div>
                {loading ? <div className='pageSimpleLoader'>Loading...</div> : null}
                {!loading && <div className={data.length == 0 ? "alert alert-info" : "d-none"}>No recent orders found</div>}
                {data.length > 0 && (
                    <div className="table-responsive border-top">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th>Phone</th>
                                    <th>QTY</th>
                                    <th>Cost</th>
                                    <th>Status</th>
                                    <th>Date</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((data, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{data.name}</td>
                                            <td>{data.phoneNumber}</td>
                                            <td>{data.productsQuantity}</td>
                                            <td>{setting?.currencySymbol} {data.totalCost}</td>
                                            <td>
                                                {data?.status == "PENDING" && <span className="badge bg-warning">{data?.status}</span>}
                                                {data?.status == "ACCEPTED" && <span className="badge bg-success">{data?.status}</span>}
                                                {data?.status == "REJECTED" && <span className="badge bg-danger">{data?.status}</span>}
                                                {data?.status == "DELIVERED" && <span className="badge bg-success">{data?.status}</span>}
                                                {data?.status == "RETURNED" && <span className="badge bg-info">{data?.status}</span>}
                                            </td>
                                            <td>{moment(data.createdAt).fromNow()}</td>
                                            <td>
                                                <Link to={`/dashboard/order?id=${data?._id}`}>
                                                    <small>View</small>
                                                </Link>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                )}

            </div>
        </>
    )
}

export default RecentOrders